import { Component, Vue } from 'vue-property-decorator';
import DeleteAccountFirstStepComponent from '@/account/delete/delete-account-first-step.vue';
import DeleteAccountSecondStepComponent from '@/account/delete/delete-account-second-step.vue';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({
  computed: {},
  methods: {},
  components: {
    deleteAccountFirstStepComponent: DeleteAccountFirstStepComponent,
    deleteAccountSecondStepComponent: DeleteAccountSecondStepComponent,
  },
})
export default class MyPageDelete extends Vue {
  @appStoreState.Getter
  getIsOpenFirstStepDeleteAccountModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenFirstStepDeleteAccountModal!: (payload: any) => void;

  @appStoreState.Getter
  getIsOpenSecondStepDeleteAccountModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenSecondStepDeleteAccountModal!: (payload: any) => void;

  deleteAccount() {
    this.setIsOpenFirstStepDeleteAccountModal(true);
  }

  back() {
    this.$router.push('/my-page/detail');
  }
}
